import Axios from "./axios";

const resource = "shop-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}